import { useQuery } from "react-query";
import ProductsService from "../api/services/ProductsService";

export interface IPortalSiteInfo {
  name: string;
  description: string;
  gig_agency_name: string;
  location: string;
  partnership_name: string;
  phone_number: string;
}

interface IPortalSiteInfoResponse {
  data: {
    info: IPortalSiteInfo;
  };
}

export const usePortalSiteInfo = () => {
  const { data } = useQuery<IPortalSiteInfoResponse>(
    ["portal-site-info"],
    async () => await ProductsService.getPortalSiteInfo(),
  );

  return {
    data: data?.data?.info,
  };
};
